import React from 'react';
import headerImg from '../../assets/images/image 1.png'
import { NavLink, useNavigate } from 'react-router-dom';
import { Button } from 'components';
const Header = ({btnText,btnLink}) => {
  const navgattion = useNavigate()
  return (
    <header className='w-[95%] md:w-full' style={styles.header}>

      <div className='ml-[10px] md:ml-[0px]' style={styles.logoContainer}>
       <NavLink to='/' className='marginclass'> <img src={headerImg} alt="Logo" style={styles.logo} /></NavLink>
      </div>
      <nav className='mr-[10px] md:mr-[0px]' style={styles.nav}>
        <ul style={styles.navList} >
              {/* <Button onClick={()=> navgattion('/sign-in')}  shape="round" className="min-w-[100px] sm:px-1" style={{fontSize:'15px',background:'white',color:'black'}}>
                    Sign in
                  </Button> */}
                  {/* <Button onClick={btnLink}   shape="round" className="min-w-[120px] sm:px-1 " style={{fontSize:'15px',background:'white',color:'black',paddingRight:'10px',paddingLeft:'10px'}}>
                    {btnText}
                  </Button> */}
         
         
        </ul>
      </nav>
    </header>
  );
};

const styles = {
  // header: {
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'space-between',
  //   position:'relative',
  //   padding: '10px',
  //   color: 'white',
  //   zIndex: 99,
  //   // width:'95%'
  // },
  header: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  padding: '16px 20px',
  background: 'transparent',
  zIndex: 50,
},

 
  logo: {
    width: '170px',
  },
 
  navList: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    gap:20
  },
  navItem: {
    marginLeft: '20px',
  },
};

export default Header;
